import FolderCard from "./components/FolderCard/FolderCard";
import ObjectCard, { ObjectCardProps } from "./components/ObjectCard/ObjectCard";

import "./LibraryObjectCard.css";

type Props = ObjectCardProps & {
  asFolder?: boolean;
};

export default function LibraryObjectCard(props: Props) {
  return props.asFolder ? <FolderCard {...props} /> : <ObjectCard {...props} />;
}
